/**
 * 本地账号密码登录页（测试/内网环境使用）
 *
 * 生产环境（healthsafety.cn 域名下）走 shouqian 统一登录（父域 Cookie SSO），
 * 本页面不会展示；测试环境（IP/localhost/其他域名）无法使用 SSO Cookie，
 * 通过本页面用数据库中的账号密码登录（后端 /api/auth/login 一直保留）。
 */
import React, { useState } from 'react';
import { authApi } from '../services/api';

const LocalLogin: React.FC = () => {
  // 测试环境预填默认测试账号，直接点"登录"即可
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('admin123');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username.trim() || !password) {
      setError('请输入用户名和密码');
      return;
    }
    setError('');
    setSubmitting(true);
    try {
      const res = await authApi.login(username.trim(), password);
      const { access_token, refresh_token, user } = res.data;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);
      localStorage.setItem('user', JSON.stringify(user));
      // 整页跳转，确保各模块以新登录态初始化
      window.location.href = '/projects';
    } catch (err: any) {
      const detail = err?.response?.data?.detail;
      setError(
        detail === 'Incorrect username or password'
          ? '用户名或密码错误'
          : detail === 'Account is disabled'
            ? '账号已被禁用'
            : '登录失败，请稍后重试'
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-sm bg-white rounded-xl shadow-lg p-8">
        <h1 className="text-xl font-bold text-gray-900 text-center">AI写标书助手</h1>
        <p className="mt-1 text-sm text-gray-500 text-center">测试环境账号登录</p>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">用户名</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              autoComplete="username"
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none"
              placeholder="请输入用户名"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">密码</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none"
              placeholder="请输入密码"
            />
          </div>

          {error && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="w-full rounded-lg bg-blue-600 text-white py-2 text-sm font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {submitting ? '登录中...' : '登 录'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LocalLogin;
